// removed by extract-text-webpack-plugin
module.exports = {"Select":"src-components-ProductType-__ProductTypeImageModal-module___Select"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductType/ProductTypeImageModal.module.css
// module id = 1242
// module chunks = 1